import { useMemo } from "react";
import { Nav } from "react-bootstrap";
import { useMediaQuery } from 'react-responsive';

import adminStore from "../stores/Admin";
import userStore from "../stores/User";

// Everything on the dashboard is approver-only except Featured, which feature
// admins get as well. Keeping the list here means AdminPage and this nav can
// never drift apart about who sees what.
export const ADMIN_TABS: { key: string; label: string; featureAdmin?: boolean }[] = [
    { key: "users", label: "Users" },
    { key: "flagged", label: "Flagged Records" },
    { key: "deleted", label: "Deleted Records" },
    { key: "tools", label: "Tools" },
    { key: "stats", label: "Statistics" },
    { key: "suspicious", label: "Suspicious Activity" },
    // Site-wide defaults (what used to be the Free column).
    { key: "benefits", label: "Benefits" },
    // Campaign-tier matrix only. $0 tiers still belong here.
    { key: "patreon", label: "Patreon" },
    { key: "featured", label: "Featured", featureAdmin: true },
];

export function useVisibleAdminTabs() {
    const isApprover = userStore((state) => state.data?.isApprover);

    // Memoized so callers can safely use the result as an effect dependency.
    return useMemo(
        () => (isApprover ? ADMIN_TABS : ADMIN_TABS.filter((tab) => tab.featureAdmin)),
        [isApprover]
    );
}

function AdminNav() {
    const isSmall = useMediaQuery({ query: '(max-width: 576px)' });

    const activeTab = adminStore((state) => state.activeTab);
    const setActiveTab = adminStore((state) => state.setActiveTab);
    const tabs = useVisibleAdminTabs();

    // One tab means there is nothing to navigate between.
    if (tabs.length < 2) {
        return null;
    }

    return (
        <Nav
            variant={isSmall? "underline" : "tabs"}
            defaultActiveKey={activeTab}
            className="mb-4"
            onSelect={(selectedKey) => setActiveTab(selectedKey || "")}
        >
            {tabs.map((tab) => (
                <Nav.Item key={tab.key}>
                    <Nav.Link eventKey={tab.key}>{tab.label}</Nav.Link>
                </Nav.Item>
            ))}
        </Nav>
    );
}

export default AdminNav;
